import { render, staticRenderFns } from "./baseIncoTerm.vue?vue&type=template&id=46f6da13&"
import script from "./baseIncoTerm.vue?vue&type=script&lang=js&"
export * from "./baseIncoTerm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../../Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('46f6da13')) {
      api.createRecord('46f6da13', component.options)
    } else {
      api.reload('46f6da13', component.options)
    }
    module.hot.accept("./baseIncoTerm.vue?vue&type=template&id=46f6da13&", function () {
      api.rerender('46f6da13', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/cargo/v0/Information/components/basicData/baseIncoTerm.vue"
export default component.exports